import React from 'react';
import { ShieldCheck, BrainCircuit, Users, Sprout } from 'lucide-react';
import { useTheme } from './theme-provider';

const HeroSection = () => {
  const { theme } = useTheme();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <div id="hero" className="relative bg-brand-dark text-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          {/* Logo and Title */}
          <div className="flex items-center justify-center mb-8">
            <h1 className="text-5xl font-serif hero-heading tracking-wide flex items-center gap-3">
              Just
              <img
                src="/images/logo.webp"
                alt="Rest"
                className="w-16 h-16 rounded-lg inline-block"
              />
            </h1>
          </div>
          
          <h2 className="text-3xl font-semibold text-coral-400 mb-6 font-serif serif-letter-spacing">
            Empowering Communities Through Technology
          </h2>
          
          <p className="text-xl max-w-3xl mx-auto mb-12 font-serif-body leading-relaxed">
            We provide accessible technology solutions to help underserved local businesses thrive
            in the digital economy
          </p>
          
          {/* CTA Buttons */}
          <div className="flex flex-wrap justify-center gap-6 mb-16">
            <button 
              onClick={() => scrollToSection('chat')}
              className="bg-coral-500 hover:bg-coral-600 text-white font-medium py-3 px-6 rounded-full transition duration-300 shadow-lg cursor-pointer"
            >
              Ask Our AI Assistant
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className="border border-coral-400 text-coral-400 hover:bg-coral-400/10 font-medium py-3 px-6 rounded-full transition duration-300 cursor-pointer"
            >
              Request a Consultation
            </button>
          </div>
          
          {/* Features grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {/* Feature 1 */}
            <div className="bg-black bg-opacity-40 border border-coral-900/50 rounded-lg p-6 flex flex-col items-center shadow-lg">
              <div className="mb-4 text-coral-400">
                <ShieldCheck size={48} />
              </div>
              <h3 className="text-xl font-semibold mb-2 font-serif">Faith-Driven Service</h3>
              <p className="text-gray-300 text-center">
                Applying Christian principles to guide our approach to technology and community development
              </p>
            </div>
            
            {/* Feature 2 */}
            <div className="bg-black bg-opacity-40 border border-coral-900/50 rounded-lg p-6 flex flex-col items-center shadow-lg">
              <div className="mb-4 text-coral-400">
                <BrainCircuit size={48} />
              </div>
              <h3 className="text-xl font-semibold mb-2 font-serif">Technical Excellence</h3>
              <p className="text-gray-300 text-center">
                Delivering professional-grade solutions with integrity and expertise
              </p>
            </div>
            
            {/* Feature 3 */}
            <div className="bg-black bg-opacity-40 border border-coral-900/50 rounded-lg p-6 flex flex-col items-center shadow-lg">
              <div className="mb-4 text-coral-400">
                <Users size={48} />
              </div>
              <h3 className="text-xl font-semibold mb-2 font-serif">Community Empowerment</h3>
              <p className="text-gray-300 text-center">
                Building capacity within local businesses to thrive in the digital age
              </p>
            </div>
            
            {/* Feature 4 */}
            <div className="bg-black bg-opacity-40 border border-coral-900/50 rounded-lg p-6 flex flex-col items-center shadow-lg">
              <div className="mb-4 text-coral-400">
                <Sprout size={48} />
              </div>
              <h3 className="text-xl font-semibold mb-2 font-serif">Sustainable Growth</h3>
              <p className="text-gray-300 text-center">
                Creating lasting positive impact through education and mentorship
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
